import { AubadeComponent } from "js/front/bootstrap";
import { gsap } from "gsap";
import { customization } from "storage";
import { CartItemSurface } from "./CartItemSurface";
import { CartItemUnitary } from "./CartItemUnitary";
import Cookie from "js-cookie";
import { ScrollTrigger } from "gsap/all";

class Cart extends AubadeComponent {
    constructor(e, b) {
        super(e, b);

        this.st = null;

        this.projectId = e.dataset.uuid;

        this.productUl = e.querySelector(".products ul");

        this.priceHt = e.querySelector(".price-ht");
        this.priceTva = e.querySelector(".price-tva");
        this.priceTtc = e.querySelector(".price-ttc");

        this.saveBtn = e.querySelector(".save-btn");
        this.buttonPrint = e.querySelector(".print-btn");
        this.shareBtn = e.querySelector(".share-project-btn");
        this.rdvBtn = e.querySelector(".rdv-btn");
        this.rdvBtn2 = e.querySelector(".button-take-appointment");

        this.sharePopin = e.querySelector(".fps-share-project");
        this.modalityPopin = e.querySelector(".modality-popin");

        this.header = this.bootstrap.components.get(
            document.querySelector("header")
        );
        this.modality = document.getElementById("modality");

        this.first = true;

        this.body = document.querySelector("body");

        this.left = e.querySelector(".left-dk");

        this.right = e.querySelector(".right-dk");
    }

    init() {
        this.cSharePopin = this.components.get(this.sharePopin);
        this.cModality = this.components.get(this.modality);
        this.cModalityPopin = this.components.get(this.modalityPopin);
    }

    attach() {
        customization.on("product-modified", this.fillCart);
        customization.on("product-removed", this.fillCart);
        customization.on("customization-loaded", this.fillCart);

        this.shareBtn.addEventListener("click", this.onShare);
        this.saveBtn.addEventListener("click", this.onSave);
        this.rdvBtn.addEventListener("click", this.onRDV);
        if (this.rdvBtn2) this.rdvBtn2.addEventListener("click", this.onRDV);
        this.buttonPrint.addEventListener("click", this.onPrint);

        this.cModalityPopin.on("link", this.onModality);

        this.setupStickyButton();

        window.addEventListener("resize", this.onResize);
    }

    detach() {
        customization.off("product-modified", this.fillCart);
        customization.off("product-removed", this.fillCart);
        customization.off("customization-loaded", this.fillCart);

        this.shareBtn.removeEventListener("click", this.onShare);
        this.saveBtn.removeEventListener("click", this.onSave);
        this.rdvBtn.removeEventListener("click", this.onRDV);
        this.rdvBtn2.removeEventListener("click", this.onRDV);
        this.buttonPrint.removeEventListener("click", this.onPrint);

        this.cModalityPopin.off("link", this.onModality);

        this.body.classList.remove("modality-open");

        window.removeEventListener("resize", this.onResize);
    }

    onResize = () => {
        this.setupStickyButton();
    };

    setupStickyButton = () => {
        this.stickyTl?.kill();
        if (this.viewport.width < 1010) {
            this.stickyTl = gsap.timeline({
                scrollTrigger: {
                    trigger: this.rdvBtn,
                    toggleActions: "play none none reset",
                    start: "bottom top",
                    end: "bottom top"
                }
            });

            this.stickyTl.fromTo(this.rdvBtn2, { opacity: 0 }, { opacity: 1 });
        }
    };

    onShare = () => {
        dataLayer.push({ event: "Simulateur SdB - CTA Partage" });
        this.cSharePopin.show();
    };

    onModality = () => {
        this.body.classList.add("modality-open");
        this.cModality.open();
    };

    onRDV = () => {
        dataLayer.push({ event: "Simulateur SdB - CTA RDV" });
    };

    onPrint = () => {
        dataLayer.push({ event: "Simulateur SdB - CTA Impression" });
    };

    onSave = async () => {
        dataLayer.push({ event: "Simulateur SdB - CTA Enregistrement" });
        const logged = Cookie.get("isLogged");

        if (!logged) {
            const iframe = document.createElement("iframe");
            iframe.src = `${AUBADE_ROOT_URL}/account/signin-iframe`;
            iframe.style.position = "absolute";
            iframe.style.top = "0px";
            iframe.style.left = "0px";
            iframe.style.width = "100%";
            iframe.style.height = "100%";
            iframe.style.zIndex = 1000;
            iframe.style.background = "white";
            iframe.style.border = "none";
            document.body.appendChild(iframe);
            this.iframe = iframe;

            window.addEventListener("message", this.onIFrameMessage, false);

            const t = gsap.timeline();
            t.fromTo(
                iframe,
                { scale: 0.7 },
                { scale: 1, ease: "quint.out", duration: 1 },
                0
            );
            t.fromTo(
                iframe,
                { opacity: 0 },
                { opacity: 1, ease: "none", duration: 0.5 },
                0
            );

            this.iframeTm = t;
            return;
        }

        this.saveProject();
    };

    async saveProject() {
        const response = await fetch(
            `${AUBADE_ROOT_URL}/account/create-sdb-project`,
            {
                method: "POST",
                credentials: "same-origin",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    uuid: this.projectId
                })
            }
        );
        if (response.ok) {
            const result = await response.json();

            if (result && result.success) {
                window.location.href = `${AUBADE_ROOT_URL}/mon-compte/projets.html`;
            }
        } else {
            if (response.status == 401) {
            } else
                console.error(
                    `Unrecognized response status [${response.status}][${response.statusText}]`
                );
        }
    }

    onIFrameMessage = event => {
        if (event) {
            switch (event.data) {
                case "success":
                    this.onSaveSignedIn();
                    break;
                case "close":
                    this.closeIframe();
                    break;
            }
        }
    };

    onSaveSignedIn = () => {
        this.closeIframe();
        this.onSave();
    };

    closeIframe = () => {
        window.removeEventListener("message", this.onIFrameMessage, false);
        if (this.iframeTm) this.iframeTm.kill();
        const t = gsap.timeline();
        t.to(this.iframe, { scale: 0.7, ease: "quint.out", duration: 0.5 }, 0);
        t.to(this.iframe, { opacity: 0, ease: "none", duration: 0.5 }, 0);
        t.add(() => {
            document.body.removeChild(this.iframe);
            this.iframe = null;
        });
    };

    open() {
        customization.load(JSON.parse(this.element.dataset.data));
        this.header.openHeaderNotHome();
        var t = gsap.timeline();

        return t;
    }
    close() {
        var t = gsap.timeline();
        return t;
    }

    fillCart = async () => {
        this.productUl.innerHTML = "";

        const html = [];
        customization.products.forEach(product => {
            if (product.isUser) {
                html.push(
                    product.product.entity.install_price &&
                        product.product.entity.install_price.type == "m2"
                        ? CartItemSurface.template(product)
                        : CartItemUnitary.template(product)
                );
            }
        });

        this.productUl.innerHTML = html.join("");
        await this.bootstrap.components.setup();

        this.updatePrices();
    };

    updatePrices = () => {
        this.priceHt.innerText = customization.formattedTotalPriceHT;
        this.priceTva.innerText = customization.formattedTotalPriceTVA;
        this.priceTtc.innerText = customization.formattedTotalPriceTTC;
    };
}

export { Cart };
